import Box from '@mui/material/Box';
import React, { useEffect, useRef } from 'react';

import { MAP_SLOT_LAYOUT_SX } from './mapChannels';
import { useMapChannel } from './MapProvider';

// A page renders <MapSlot> to position the shared map for `channel`. The slot
// claims the channel on mount (provider moves the node in), pushes prop updates,
// and releases on unmount (provider parks the node). The map node fills the slot.
const MapSlot = ({ channel, layout = 'searchColumn', sx = null, ...mapProps }) => {
  const { claim, update, release } = useMapChannel();
  const slotRef = useRef(null);
  const claimedRef = useRef(false);
  const propsRef = useRef(mapProps);
  propsRef.current = mapProps;

  useEffect(() => {
    if (slotRef.current) {
      claim(channel, slotRef.current, propsRef.current);
      claimedRef.current = true;
    }
    return () => {
      release(channel);
      claimedRef.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channel]);

  // Push prop changes after each render (provider shallow-compares to skip no-ops).
  useEffect(() => {
    if (claimedRef.current) update(channel, propsRef.current);
  });

  const layoutSx = MAP_SLOT_LAYOUT_SX[layout] || MAP_SLOT_LAYOUT_SX.searchColumn;
  return <Box ref={slotRef} sx={sx ? [layoutSx, sx] : layoutSx} />;
};

export default MapSlot;
